import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../core/services/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.html',
  styleUrls: ['./login.scss'],
  standalone: true,
  imports: [MatButtonModule],
})
export class Login {
  private authService = inject(AuthService);

  login(): void {
    this.authService.login();
  }
}
